import capitalize from "lodash-es/capitalize"
import React from "react"
import { useFormContext } from "react-hook-form"

import commonStyles from "./ProjectBudgetForm.module.css"

import DropdownSelector from "~/common/DropdownSelector"

import { RATE_TYPES, RateTypeSelection } from "~/GLOBALVARS"

import { useProjectBudgetFormContext } from "./ProjectBudgetFormProvider"
import Column from "./TableColumn"
import Row from "./TableRow"
import { ProjectBudgetFormData } from "./formTypes"

type Props = {
  rowClassName?: string
  budgetColumnLabel?: string
}

const BudgetTableHeader: React.FC<Props> = (props) => {
  const { budgetColumnLabel, rowClassName } = props

  const { watch, setValue } = useFormContext<ProjectBudgetFormData>()
  const formData = watch()
  const { showFinancialColumns, rateType } = useProjectBudgetFormContext()

  const handleChangeRateType = (newRateType: RateTypeSelection) => {
    setValue("rateType", newRateType.value)
  }

  const finalBudgetLabel =
    budgetColumnLabel || `${capitalize(formData.budgetMethod)} Budget`

  return (
    <Row heading className={rowClassName}>
      <Column>Role</Column>
      {showFinancialColumns && <Column>Project Rate</Column>}
      <Column className={commonStyles.justifyEnd}>
        <DropdownSelector
          selectedValue={rateType}
          options={RATE_TYPES}
          onChange={handleChangeRateType}
          dataTestId="project-rate-types"
        />
      </Column>
      {showFinancialColumns && (
        <Column className={commonStyles.alignRight}>{finalBudgetLabel}</Column>
      )}
    </Row>
  )
}

export default BudgetTableHeader
